import { useEffect, useState } from "react";
import {
  Box,
  Container,
  Grid,
  Paper,
  Typography,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Divider,
  Button,
  Tabs,
  Tab,
  Stack,
  CardMedia,
  TextField,
} from "@mui/material";
import { Info, Mail, MoneyOff, Settings } from "@mui/icons-material";
import { getApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";

// TabPanel component for better accessibility and organization
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      style={{ width: "100%", height: "100%" }}
      {...other}
    >
      {value === index && <Box sx={{ height: "100%" }}>{children}</Box>}
    </div>
  );
}

export default function TempleDonation() {
  const [amount, setAmount] = useState(0);
  const [tabValue, setTabValue] = useState(0);
  const [donationItem, setDonationItem] = useState(null);
  const tabLabels = ["General", "Custom"];

  const getAllDonations = async () => {
    const response = await getApi(apiEndPoints.getAllDonations);
    console.log(response);
    if (response && response.status === 200) {
      console.log("Donation items:", response);
      setDonationItem(response?.data?.data);
    }
  };

  const predefinedAmounts = [
    "₹101",
    "₹501",
    "₹1001",
    "₹1116",
    "₹2001",
    "₹5001",
  ];
  const numpadButtons = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];

  const handleNumberClick = (num) => {
    if (amount === 0) {
      setAmount(parseInt(num));
    } else {
      setAmount(parseInt(`${amount}${num}`));
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Icons for tabs
  const tabIcons = [
    <MoneyOff size={20} />,
    <Settings size={20} />,
    <MoneyOff size={20} />,
    <Info size={20} />,
    <Mail size={20} />,
  ];

  useEffect(() => {
    getAllDonations();
  }, []);

  return (
    <Stack direction="row" spacing={0} sx={{ height: "100vh" }}>
      <Box
        sx={{
          borderRight: 1,
          borderColor: "divider",
          width: "80px",
          bgcolor: "white",
        }}
      >
        <Tabs
          orientation="vertical"
          variant="fullWidth"
          value={tabValue}
          onChange={handleTabChange}
          aria-label="Temple donation options"
          sx={{
            height: "100%",
            "& .MuiTabs-flexContainer": {
              height: "100%",
              alignItems: "stretch",
            },
            "& .MuiTabs-indicator": {
              left: 0,
              width: "4px",
              backgroundColor: "#f69320",
            },
            "& .MuiTab-root": {
              minHeight: "80px",
              minWidth: "80px",
              padding: 0,
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
            },
          }}
        >
          {tabLabels.map((label, index) => (
            <Tab
              key={index}
              disabled={index > 1} // Only first two tabs are enabled
              icon={
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <IconButton
                    sx={{
                      color: index <= 1 ? "#f69320" : "#666",
                      bgcolor: tabValue === index ? "#ffefd9" : "transparent",
                      "&:hover": index <= 1 ? { bgcolor: "#fff9f0" } : {},
                    }}
                    disableRipple
                  >
                    {tabIcons[index]}
                  </IconButton>
                  <Typography variant="caption" sx={{ mt: 0.5 }}>
                    {label}
                  </Typography>
                </Box>
              }
              sx={{
                bgcolor: tabValue === index ? "#fff9f0" : "transparent",
                "&.Mui-selected": { bgcolor: "#fff9f0" },
              }}
            />
          ))}
        </Tabs>
      </Box>

      <Box sx={{ width: "100%", height: "100%" }}>
        <TabPanel value={tabValue} index={0}>
          <Box sx={{ p: 2, width: "100%" }}>
            <Grid container spacing={3}>
              {donationItem?.map((option, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Card
                    sx={{
                      m: 1,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <CardMedia
                      component="img"
                      height="140"
                      image="your-image-url.jpg"
                      alt="Donation"
                      sx={{ borderRadius: "8px 8px 0 0", objectFit: "cover" }}
                    />
                    <CardContent
                      sx={{
                        p: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        height: 180, // 👈 fixed height for uniformity
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        align="center"
                        fontWeight="bold"
                        color="#970a38"
                        sx={{
                          minHeight: 40,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }} // Ensures text alignment
                      >
                        {`${option?.title} ${
                          option?.amount > 0 ? `$${option.amount}` : ""
                        }`}
                      </Typography>

                      <TextField
                        fullWidth
                        size="small"
                        placeholder="Donations in $"
                        type="number"
                        sx={{ my: 1 }}
                      />

                      <Button
                        fullWidth
                        variant="contained"
                        sx={{
                          backgroundColor: "#970a38",
                          color: "white",
                          textTransform: "none",
                        }}
                      >
                        Donate
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <Box
            sx={{
              display: "flex !important",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box sx={{ textAlign: "center", mb: 4 }}>
              <Typography
                variant="h5"
                component="div"
                color="#f69320"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                ₹ {amount}
              </Typography>
              <Divider sx={{ my: 3 }} />
            </Box>

            <Grid container spacing={2} sx={{ mb: 3 }}>
              {predefinedAmounts.map((amt, index) => (
                <Grid item xs={4} key={index}>
                  <Button
                    variant="outlined"
                    fullWidth
                    sx={{
                      bgcolor: "#fff9f0",
                      color: "#333",
                      border: "1px solid #ffe0b2",
                      "&:hover": {
                        bgcolor: "#ffe0b2",
                        border: "1px solid #f69320",
                      },
                    }}
                  >
                    {amt}
                  </Button>
                </Grid>
              ))}
            </Grid>

            <Grid container spacing={2}>
              {numpadButtons.map((num, index) => (
                <Grid item xs={4} key={index}>
                  <Button
                    variant="outlined"
                    fullWidth
                    onClick={() => handleNumberClick(num)}
                    sx={{
                      color: "#333",
                      border: "1px solid #ddd",
                      "&:hover": {
                        bgcolor: "#f5f5f5",
                      },
                    }}
                  >
                    {num}
                  </Button>
                </Grid>
              ))}
            </Grid>
          </Box>
        </TabPanel>
      </Box>
    </Stack>
  );
}
